<template>
  <div class="max-centred text-center">
    <h1 class="text-h2">RazorPayX Azure Connector</h1>
    <h4 class="text-h4 my-12">Connect your RazorPayX account with your Beezlabs Azure account</h4>
    <p>
      This connection helps you in using RazorPayX and Azure features in internal Beezlabs tools like the Attendance
      tracking system.
    </p>
    <p>In order to link your accounts successfully, click on the "Link" button below.</p>
    <p>
      If you have previously linked you accounts and your data has changed, you can click on "Link" again to update your
      data. You can check if you have previously linked and what data is linked by clicking on "Check" button below.
    </p>
    <p class="mt-8">
      <v-btn color="primary" class="ma-2" @click="link">Link</v-btn>
      <v-btn color="secondary" class="ma-2" @click="check">Check</v-btn>
    </p>

    <div v-if="userData">
      <p>Azure OID: {{ userData.azure_oid }}</p>
      <p>Display Name: {{ userData.display_name }}</p>
      <p>Email: {{ userData.email }}</p>
      <p>Employee ID: {{ userData.employee_id }}</p>
    </div>

    <v-snackbar v-model="showNotification" timeout="5000" tile :color="snackBarColor()">
      <div v-if="success">Your accounts were successfully linked!</div>
      <div v-else>Some error occurred while linking. Please reach out to the owner of this application.</div>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'LandingPage',
  data: () => ({
    userData: null,
    showNotification: false,
    success: true
  }),
  methods: {
    async link() {
      try {
        await this.$store.dispatch('link')
        this.userData = await this.$store.dispatch('check')
        this.success = this.userData && Object.keys(this.userData).length > 0
      } catch (err) {
        this.success = false
      }
      this.showNotification = true
    },
    async check() {
      this.userData = await this.$store.dispatch('check')
    },
    snackBarColor() {
      return this.success ? 'green--text text--lighten-1' : 'red--text text--lighten-1'
    }
  }
}
</script>

<style scoped>
.max-centred {
  max-width: 700px;
  margin: 0 auto;
}
</style>
